import AuthGuard from "context/auth/AuthGuard"
import { UserRoles } from "constants/userRoles"
import { Box, CircularProgress, Divider, Stack, TextField, useTheme } from "@mui/material"
import { useTranslation } from "react-i18next";
import { useStatistics } from "hooks/useStatistics";
import { UserTrainingStatisticsTable } from "components/StatisticsDataTable/StatisticsDataTable";
import { useEffect, useState } from "react";
import { useGetLessons } from "hooks/useGetLessons";
import { useParams } from "react-router-dom";
import { UserTrainingStatistics } from "@models/UserTrainingStatistics";
import { StyledMainStack, TitleTypography, StyledAutocomplete, SubtitleTypography } from './StatisticsPage.styles';

export const StatisticsPage = () => {
    const [selectedLessonIds, setSelectedLessonIds] = useState<string[]>([]);
    const [inputValue, setInputValue] = useState<string>('');
    const { t } = useTranslation();
    const { statistics, gettingStatistics } = useStatistics();
    const [ filteredStatistics, setFilteredStatistics ] = useState<UserTrainingStatistics[]>([]);
    const { lessons, fetchingLessons } = useGetLessons();
    const theme = useTheme();
    const { lessonId } = useParams();

    useEffect(() => {
        if (lessonId) {
            setSelectedLessonIds([lessonId])
        }
    }, [lessonId]);

    useEffect(() => {
        let filtered = statistics;
        if (selectedLessonIds.length > 0) {
            filtered = filtered.filter(s => selectedLessonIds.includes(s.lessonId));
        }
        setFilteredStatistics(filtered);
    }, [statistics, selectedLessonIds]);

    return <AuthGuard requiredRoles={[UserRoles.ADMIN, UserRoles.Patron, UserRoles.PatronLight]}>            
    <StyledMainStack>
        <TitleTypography variant="h4" component="div">
            {t('statistics.title')}
        </TitleTypography>
        <SubtitleTypography variant="subtitle1">
            {t('statistics.subtitle')}
        </SubtitleTypography>
        <Divider />
        <Stack direction={'row'}>
          <Box width='25%' paddingTop={theme.spacing(4)} paddingRight={theme.spacing(2)}>
            {fetchingLessons ? (
              <CircularProgress />
            ) : (
                <StyledAutocomplete
                    multiple
                    id="statistics-autocomplete"
                    options={lessons}
                    getOptionLabel={(option: any) => option.name}
                    value={lessons.filter((lesson) => selectedLessonIds.includes(lesson.id))}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue, reason) => {
                        if (reason !== 'reset') {
                        setInputValue(newInputValue);
                        }
                    }}
                    onChange={(event, newValue: any) => {
                        setSelectedLessonIds(newValue.map((lesson: any) => lesson.id));
                    }}
                    renderInput={(params) => (
                        <TextField {...params} variant="outlined" label={t('statistics.lessons')} />
                    )}
                    noOptionsText={t('statistics.noOptions')}
                    />
            )}
          </Box>
          <Box width={'75%'} paddingTop={theme.spacing(4)} paddingLeft={theme.spacing(2)}>
            <UserTrainingStatisticsTable data={filteredStatistics} gettingStatistics={gettingStatistics} />
          </Box>
        </Stack>
    </StyledMainStack>
    </AuthGuard>
}